import { observer } from 'mobx-react';
import * as React from 'react';
import LaresPostForm from '../components/LaresPostForm';
import useStores from '../stores/UseStores';

const LaresPostFormPage = observer((): React.JSX.Element => {
  const {
    routeStore: {
      decodedParams: { gotoUrl, lares },
    },
  } = useStores();

  return <LaresPostForm formPostUrl={gotoUrl} lares={lares} />;
});

export default LaresPostFormPage;
